
export class ChangePasswordModel {
    public current_password: string;
    public new_password: string;
    public confirm_password: string;
}
